import React from 'react';

const MainContent = ({ children, collapsed = false, publicView = false }) => {
  return (
    <main className={`main-content ${publicView ? 'public-view' : ''} ${collapsed ? 'collapsed' : ''}`}>
      {children}
    </main>
  );
};

export default MainContent;
